import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import { locale, loadMessages } from 'devextreme/localization';
import ptMessages from 'devextreme/localization/messages/pt.json';
import config from 'devextreme/core/config';

import { ThemeService } from './core/services/theme.service';
import { environment } from '../environments/environment';

registerLocaleData(localePt, 'pt');

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  readonly themeService = inject(ThemeService);

  constructor() {
    loadMessages(ptMessages);
    locale(navigator.language);

    config({
      licenseKey: environment.devKey,
      defaultCurrency: 'BRL',
    });
  }
}
